import { DateInput } from "@mantine/dates";
import "dayjs/locale/sr";
import "dayjs/locale/de";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

import i18n from "config/localization/i18n";
dayjs.extend(customParseFormat);

const CustomDatePicker = (props: any) => {
  const { clearable, required, disabled, ...restProps } = props;

  const languageFromI18n = i18n.language.toLowerCase().split("-")[0] as
    | "EN"
    | "DE"
    | "SR"
    | "AL"
    | "ES"
    | "FR"
    | "IT"
    | "PT"
    | "TR";

  const parseDate = (value: string) => {
    const formats = ["DD.MM.YYYY", "D.M.YYYY", "DD.M.YYYY", "D.MM.YYYY"];
    for (const format of formats) {
      if (dayjs(value, format, true).isValid()) {
        return dayjs(value, format).toDate();
      }
    }
    return null;
  };

  return (
    <DateInput
      {...restProps}
      withAsterisk={required}
      clearable={clearable ?? !disabled}
      disabled={disabled}
      inputWrapperOrder={["label", "input", "error", "description"]}
      locale={languageFromI18n}
      valueFormat={"DD.MM.YYYY"}
      dateParser={(value) => parseDate(value)}
    />
  );
};

export default CustomDatePicker;
